import { IQuestion } from 'types';

export const getQuestionResponse = (
  questions: IQuestion[],
  response: { id: number; response: string }[],
) => {
  const reponseMap = new Map<number, string>();
  response.forEach((i) => {
    reponseMap.set(Number(i.id), i.response);
  });

  return questions.map((i) => {
    return { ...i, response: parseResponse(reponseMap.get(i.id) || '') };
  });
};

export const parseResponse = (response: string) => {
  try {
    const data = JSON.parse(response);
    if (typeof data === 'string' || typeof data === 'number')
      return String(data);

    return Object.keys(data)
      .filter((k) => k !== 'etcKey')
      .map((k) => `${data[k]}`)
      .join(', ');
  } catch {
    return response;
  }
};

export const parseResponseValues = (response: string): string[] => {
  try {
    const data = JSON.parse(response);
    if (typeof data === 'string' || typeof data === 'number')
      return [String(data)];

    return Object.keys(data)
      .filter((k) => k !== 'etcKey')
      .map((k) => `${data[k]}`);
  } catch {
    return [response];
  }
};
